<template>
    <b-card>
        <!-- filter  -->
        <div v-if="loading" class="text-center mt-4">
            <b-spinner label="Loading..."></b-spinner>
        </div>
        <div class="col-12 mt-16">
            <div>
                <b-row class="align-items-center">
                    <b-col lg="3" class="my-1">
                        <b-form-group label="" label-for="filter-input" label-cols-sm="1" label-align-sm="right"
                            label-size="sm" class="mb-0">
                            <b-input-group size="sm">
                                <b-form-input id="filter-input" v-model="filter" type="search"
                                    placeholder="Type to Search"></b-form-input>
                                <b-input-group-append>
                                    <b-button @click="applyFilter" :disabled="!filter"
                                        variant="primary">Apply</b-button>
                                    <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                      <!-- .. Filter  for   date-->
                      <b-col lg="2" class="my-1">
                    <b-form-input id="start-date" v-model="startDateFilter" type="date"
                        placeholder="Select start date"></b-form-input>
                </b-col>
                <b-col lg="2" class="my-1">
                    <b-form-input id="end-date" v-model="endDateFilter" type="date" placeholder="Select end date"
                        @change="changeDate"></b-form-input>
                </b-col>
                    <!-- Filter  for   date-  -->
        
                    <b-col lg="3" class="my-1 d-flex justify-content-end">
                    <b-form-group id="input-group-1" label="Vehicle Status:" label-for="name">        
                        <select 
                            class="form-control" 
                            v-model="newVehicleStatus" 
                            @change="fetchDataBasedOnVehicleStatus"  
                            required>
                            <option value="" disabled selected>Select status of vehicle</option>
                            <option value="New">New Vehicle</option>
                            <option value="Sale">Sale Vehicle</option>
                        </select>
                    </b-form-group>
                </b-col>

                    <b-col lg="2" class="my-1 d-flex justify-content-end">
                        <!-- <b-button @click="exportDataToCSV" variant="primary" class="mb-8 mr-8">Export</b-button> -->
                        <b-button @click="exportAllDataToCSV" variant="primary" class="mb-8 mr-8">Export</b-button>
                    </b-col>
                </b-row>
            </div>
        </div>
        <!-- filter end -->
        <b-row>
            <div class="col-12 mt-16">
                <b-skeleton-table
                    v-if="loading"
                    :rows="perPage"
                    :columns="fields.length"
                    animation="wave"
                    bordered
                    class="mb-3"
                    />
                <b-table v-else id="dataTable" :items="users" :busy.sync="loading" :fields="fields" :current-page="currentPage"
                    :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" show-empty responsive striped hover  class="custom-zebra">
                 
                    <template v-slot:head()="data">
                        <span :style="{ color: columnColors[data.field.key] }">{{ data.label }}</span>
                    </template>
                    <template v-slot:cell()="row">
                        <span :style="{ color: columnColors[row.field.key] }">{{ row.value || 'N/A' }}</span>
                    </template>
                    <template #cell(actions)="row">
                        <b-button v-b-tooltip.hover title="Show MarketPlace Vehicle" @click="showDrivers(row.item.id)" variant="link" class="p-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" style="
                color: rgba(0, 255, 195, 0.87);
                margin-left: 6px;
                margin-bottom: 10px;
              " class="bi bi-eye" viewBox="0 0 16 16">
                                <path
                                    d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                <path
                                    d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                            </svg>
                        </b-button>
                        <!-- delete -->
                        <b-button  v-b-tooltip.hover title="Delete Marketplace Vehicle" @click="showDeleteConfirmation(row.item.id)" variant="link" class="p-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"
                                style="color: red; margin-left: 6px; margin-bottom: 10px" class="bi bi-eye"
                                viewBox="0 0 16 16">
                                <!-- ... your SVG path ... -->
                                <path
                                    d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                            </svg>
                        </b-button>
                        <b-modal v-model="showDeleteConfirmations" title="Delete Confirmation">
                            <p>Are you sure you want to delete this Marketplace Vehicle?</p>
                            <template #modal-footer>
                                <b-button variant="primary" @click="deleteItem(itemIdToDelete)">Delete</b-button>
                                <b-button variant="primary" @click="showDeleteConfirmations = false">Cancel</b-button>

                            </template>
                        </b-modal>
                        <!-- end delete -->

                        <b-button  v-b-tooltip.hover title="Edit Marketplace Vehicle" @click="editUser(row.item.id)" variant="link" class="p-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"
                                style="color: orange; margin-left: 10px; margin-bottom: 10px" class="bi bi-pencil"
                                viewBox="0 0 16 16">

                                <path
                                    d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
                            </svg>
                        </b-button>
                    </template>
                                  <!-- image  show code here  -->
                                  <template #cell(image)="row">
                        <img :src="'https://wossdb.wossautoid.com/' + row.item.image" alt="Picture" width="100"
                            height="100" />
                    </template>
                    <template #cell(brand_models)="row">
                        {{ `${row.item.brand_models?.title ||''} ` }}
                    </template>
                    <template #cell(category_title)="row">
                        {{ row.item.category.title ||'N/A' }}
                    </template>
                    <template #cell(brands)="row">
                        {{ `${row.item.brands.name} ` }}
                    </template>
                    <template v-slot:cell(created_at)="data">
                        <span :style="{ color: columnColors.created_at }">{{ formatDate(data.item.created_at) }}</span>
                    </template>
                    <template v-slot:cell(created_at_time)="data">
                    {{ formatTime(data.item.created_at) }}
                    </template>
                         <!-- Color  code here  -->
                         <template #cell(color)="row">
                        <span :style="{ color: columnColors.color }">{{ row.item.color || 'N/A' }}</span>
                    </template>
                           <!-- City  code here  -->
                           <template #cell(city)="row">
                        <span :style="{ color: columnColors.city }">{{ row.item.city || 'N/A' }}</span>
                    </template>
                           <!-- Area  code here  -->
                           <template #cell(area)="row">
                        <span :style="{ color: columnColors.area }">{{ row.item.area || 'N/A' }}</span>
                    </template>
                           <!-- Country  code here  -->
                           <template #cell(country)="row">
                        <span :style="{ color: columnColors.country }">{{ row.item.country || 'N/A' }}</span>

                    </template>
                           <!-- Milaage  code here  -->
                           <template #cell(mileage)="row">
                        <span :style="{ color: columnColors.mileage }">{{ row.item.mileage || 'N/A' }}</span>

                    </template>
                           <!-- Price  code here  -->
                           <template #cell(price)="row">
                        <span :style="{ color: columnColors.price }">{{ row.item.price || 'N/A' }}</span>

                    </template>
                           <!-- Status  code here  -->
                           <template #cell(status)="row">
                        <span :style="{ color: columnColors.status }">{{ row.item.status || 'N/A' }}</span>

                    </template>
                    <b-form-group label="Filter" label-for="filter-input" label-cols-sm="3" label-align-sm="right"
                        label-size="sm" class="mb-0">
                        <b-input-group size="sm">
                            <b-form-input id="filter-input" v-model="filter" type="search"
                                placeholder="Type to Search"></b-form-input>

                            <b-input-group-append>
                                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-table>
                <div class="mx-8 d-flex justify-content-end">
                    <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage"
                        aria-controls="dataTable" @change="pageChanged"></b-pagination>
                </div>
                <b-row class="mt-16 align-items-center justify-content-end">

                    <b-row>

                    </b-row>
                </b-row>
            </div>
        </b-row>
    </b-card>
</template>

<script>
import {
    BRow,
    BCol,
    BCard,
    BButton,
    BTable,
    BFormGroup,
    BInputGroup,
    BFormInput,
    BFormSelect,
    BPagination,
    BInputGroupAppend,
    BSpinner,
    BSkeleton,
    BSkeletonTable,
} 
from "bootstrap-vue";
import axios from "../../../axios";
import Papa from "papaparse";

export default {
    data() {
        return {
            perPage: 10,
            currentPage: 1,
            sortBy: "",
            sortDesc: false,
            lastPage: 0,
            firstPageUrl: null,
            lastPageUrl: null,
            nextPageUrl: null,
            prevPageUrl: null,
            isLoading: false,
            users: [],
            fields: [
                { key: "id", sortable: true },
                { key: "year", sortable: true },
                // { key: "category_title", label:"Category Name", sortable: true },
                // { key: "brand_models", label:"Brand Model", sortable: true },
                // { key: "brands", label:"Brand Name", sortable: true },
                { key: "registration_number", sortable: true },
                { key: "engine_number", sortable: true },
                { key: "color", sortable: true },
                { key: "city", sortable: true },
                { key: "area", sortable: true },
                { key: "country", sortable: true },
                { key: "mileage", sortable: true },
                { key: "price", sortable: true },
                { key: "created_at", label: "Date", formatter: this.formatDate },
                { key: "created_at_time", label: "Time" },
                { key: "status", sortable: true },
                { key: "actions", label: "Actions" },
            ],

            columnColors: {
                year: 'green',
                color: 'orange',
                engine_number: 'brown',
                registration_number: 'blue',
                mileage: 'teal',
                country: 'cyan',
                price: 'gray', 
                created_at: 'maroon',
                created_at_time: 'navy',
                area: 'olive',
                status: 'indigo',
                city: 'indigo',
                actions: 'gold'
            },

            filter: "",
            total: 0, 
            showDeleteConfirmations: false,
            itemIdToDelete: null,
            loading: false,
            image: "",
            newVehicleStatus: "",
            startDateFilter: null,
            endDateFilter: null,
            ended_date: "",
            selected_date: "",
        };
    },

    components: {
        BRow,
        BCol,
        BCard,
        BButton,
        BTable,
        BFormGroup,
        BInputGroup,
        BFormInput,
        BFormSelect,
        BPagination,
        BInputGroupAppend,
        BSpinner,
        BSkeleton,
        BSkeletonTable,

    },
    computed: {
        sortOptions() {
            return this.fields
                .filter((f) => f.sortable)
                .map((f) => {
                    return { text: f.label, value: f.key };
                });
        },
        rows() {
            return this.users.length;
        },
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        clearFilter() {
            this.filter = '';     
            this.currentPage = 1;   
            this.fetchData();       
        },
        async fetchData() {
            this.loading = true;
            let apiUrl = "marketPlace";
            try {
                const response = await axios.post(apiUrl, {

                         page: this.currentPage, per_page: this.perPage,
                        ended_date: this.endDateFilter,
                        selected_date: this.startDateFilter,
                   
                });

                this.users = response.data.data;
                this.total = response.data.total;
                this.currentPage = response.data.current_page;
                this.perPage = response.data.per_page;
                this.lastPage = response.data.last_page;

            } catch (error) {
            } finally {
                this.loading = false;
            }
        },
        applyFilter() {
            this.loading = true;
            let apiUrl = "marketPlace"; 
            axios
                
                    .post(apiUrl, {
                        search: this.filter,
                })
                .then((response) => {
                    this.users = response.data.data;
                    this.total = response.data.total;
                    this.currentPage = response.data.current_page;
                })
                .catch((error) => {
    
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        pageChanged(newPage) {
            this.currentPage = newPage;
            this.fetchData();
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        codeClick() {
            this.codeActive = !this.codeActive;
        },
        exportAllDataToCSV() {
            this.fetchAllParents((allParents) => {
                const csv = Papa.unparse(allParents);
                const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.setAttribute("download", "exported_data.csv");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            });
        },
        fetchAllParents(callback) {
            axios
                .post("marketPlaceforExport", { params: { per_page: this.totalRows } })
                .then((response) => {
                    callback(response.data.data);
                })
                .catch((error) => {
                    console.error("Error fetching all Data:", error);
                });
        },

        editUser(userId) {
            this.$router.push({ name: "EditMarketPlace", params: { id: userId } });
        },

        showDrivers(userId) {
            this.$router.push({ name: "ViewMarketPlace", params: { id: userId } });
        },
        ///  delete
        showDeleteConfirmation(itemId) {
            this.itemIdToDelete = itemId;
            this.showDeleteConfirmations = true;
        },
        deleteItem(itemId) {

            this.itemIdToDelete = itemId;
            axios
                .delete(`marketPlaceDelete/${itemId}`)
                .then((response) => {
                    this.showDeleteConfirmations = false;
                    this.fetchData(); 
                })
                .catch((error) => {

                });
        },
        formatDate(dateString) {
            const date = new Date(dateString);
            return date.toLocaleDateString();

        },
        // Fetching   vehicle  code 
    fetchDataBasedOnVehicleStatus() {
        this.loading = true; 
        let apiUrl = "marketPlace"; 

        axios
            .post(apiUrl, {
                params: {
                    vehicle_status: this.newVehicleStatus,
                },
            })
            .then((response) => {
                // Assuming the status field in the API response matches the dropdown value
                this.users = response.data.data.filter(vehicle => 
                    (this.newVehicleStatus === 'New' && vehicle.status === 'new') || 
                    (this.newVehicleStatus === 'Sale' && vehicle.status === 'sell')
                );
                this.total = response.data.total;
                this.currentPage = response.data.current_page;
            })
            .catch((error) => {
                console.error("Error fetching data based on vehicle status:", error);
            })
            .finally(() => {
                this.loading = false; 
            });
    },
       // Display  date  code  here 
       formatDate(dateString) {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toISOString().split('T')[0]; 
    }, 
        // Display  time  code  here 
        formatTime(dateString) {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }); 
    },
    changeDate() {
            const userId = this.$route.params.id;
            this.fetchData(userId);
        },
    },
};
</script>
  <style>
  /* Zebra striping */
  .custom-zebra tbody tr:nth-of-type(odd) {
    background-color: #f0f2f5; /* darker than default */
  }

  /* Hover effect */
  .custom-zebra tbody tr:hover {
    background-color: #e0e4ea !important; /* slightly darker hover */
  }
  </style>